export default __webpack_public_path__ + "static/media/footer-linkedin.7aeb361c.svg";